var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVimeoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9224 2.82436C15.856 4.19822 14.8408 6.07948 12.8773 8.46714C10.8472 10.9613 9.12956 12.2082 7.72449 12.2082C6.85442 12.2082 6.11754 11.449 5.51609 9.92989C5.11412 8.53743 4.71261 7.14512 4.3108 5.75267C3.86389 4.23442 3.38473 3.47431 2.87243 3.47431C2.76074 3.47431 2.36982 3.69646 1.70058 4.13906L0.998047 3.28358C1.73493 2.67152 2.46195 2.0596 3.17718 1.44684C4.15999 0.64405 4.89776 0.221877 5.38946 0.179194C6.5516 0.0736864 7.26683 0.824498 7.5353 2.43177C7.82543 4.16582 8.02611 5.24443 8.13899 5.6666C8.47391 7.10526 8.84243 7.82367 9.24513 7.82367C9.55765 7.82367 10.0271 7.35712 10.653 6.42403C11.2784 5.49066 11.6133 4.78056 11.6585 4.29274C11.7475 3.48727 11.4125 3.08355 10.653 3.08355C10.2956 3.08355 9.92706 3.16131 9.54795 3.315C10.2817 1.04298 11.6838 -0.0604173 13.7533 0.00254943C15.2876 0.0450907 16.0108 0.985648 15.9224 2.82436Z",
    fill: "#32B8E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVimeoSmall);
export default __webpack_public_path__ + "static/media/vimeo-small.c5c7c952e24badb72807d9970bfa0e75.svg";
export { ForwardRef as ReactComponent };